export function logInfo(message: string, ...optionalParams: any[]) {
    console.info(`INFO: ${message}`, ...optionalParams);
}